const {
  hideElementsBySelector,
  showElementsBySelector,
} = require('../common/utils/dom');
const {
  changeViewToOnlyForm,
  changeViewToNormal,
} = require('./checkoutStage').methods;
const formHelpers = require('./formErrors');
const clientSideValidation = require('../components/clientSideValidation');

const requestInvoiceTogglerSelector = '#requestInvoice';
const requestInvoiceEditSelector = '.order-summary-invoice .checkout-main__edit-button';
const requestInvoiceRemoveSelector = '.order-summary-invoice .remove-invoice-request';
const requestInvoiceBackBtnSelector = '.request-invoice-form__back-to-order-summary';
const requestInvoiceFormSelector = '#requestInvoiceForm';

/**
 * Shows invoice block
 */
function showInvoiceBlock() {
  const orderSummarySelector = '.order-summary';
  const placeOrderBtnSelector = '.place-order';

  hideElementsBySelector(orderSummarySelector);
  hideElementsBySelector(placeOrderBtnSelector);
  hideElementsBySelector(requestInvoiceTogglerSelector);

  showElementsBySelector(requestInvoiceFormSelector);

  changeViewToOnlyForm();
}
/**
 * Shows invoice block
 */
function hideInvoiceBlock() {
  const orderSummarySelector = '.order-summary';
  const placeOrderBtnSelector = '.place-order';

  hideElementsBySelector(requestInvoiceFormSelector);

  showElementsBySelector(orderSummarySelector);
  showElementsBySelector(placeOrderBtnSelector);
  showElementsBySelector(requestInvoiceTogglerSelector);

  changeViewToNormal();
}

function updateInvoiceRequestSummary(order) {
  if (!order.billing) return;

  const { address } = order.billing.billingAddress;
  const invoiceContainerSelector = '.order-summary-invoice';
  const invoiceContainer = document.querySelector(invoiceContainerSelector);
  const invoiceCompanyName = invoiceContainer.querySelector('.order-summary-invoice__company-name');
  const invoiceCif = invoiceContainer.querySelector('.order-summary-invoice__cif');

  if (address && address.companyName && address.custom.byl_cif) {
    if (invoiceCompanyName) {
      invoiceCompanyName.textContent = address.companyName;
    }
    if (invoiceCif) {
      invoiceCif.textContent = address.custom.byl_cif;
    }

    showElementsBySelector(invoiceContainerSelector);
  } else {
    hideElementsBySelector(invoiceContainerSelector);
  }
}

function doSubmit(form) {
  const url = form.getAttribute('action');
  const formData = new FormData(form);
  formHelpers.removeCheckoutError();

  fetch(url, {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) {
        formHelpers.addCheckoutError();
      } else {
        updateInvoiceRequestSummary(data.order);
        document.querySelector(requestInvoiceTogglerSelector)
          .dataset.isInvoiceRequested = data.order.isInvoiceRequested;
        hideInvoiceBlock();
        const { handleScrollProperties } = require('./checkoutCommon').methods;
        const checkoutStages = require('./checkoutStage').stages;
        handleScrollProperties(checkoutStages.PLACE_ORDER);
      }
    })
    .catch(() => {
      formHelpers.addCheckoutError();
    });
}

module.exports = {
  methods: {
    hideInvoiceBlock,
  },
  initInvoiceEvents() {
    function handleOpenRequestInvoiceForm(event) {
      event.preventDefault();
      showInvoiceBlock();
    }

    document.querySelector(requestInvoiceTogglerSelector)?.addEventListener(
      'click',
      handleOpenRequestInvoiceForm,
    );
    document.querySelector(requestInvoiceEditSelector)?.addEventListener(
      'click',
      handleOpenRequestInvoiceForm,
    );

    // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
    document.querySelector(requestInvoiceBackBtnSelector)?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        hideInvoiceBlock();
      },
    );

    // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
    document.querySelector(requestInvoiceFormSelector)?.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();

        const form = event.target;

        // Clear previous errors
        formHelpers.clearPreviousErrors(form);

        const isValid = clientSideValidation.functions.validateForm(form, event);
        if (!isValid) return;

        doSubmit(form);
      },
    );

    // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
    document.querySelector(requestInvoiceRemoveSelector)?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const form = document.getElementById('requestInvoiceForm');
        const companyNameElement = form.querySelector('.invoiceCompanyName');
        companyNameElement.value = '';
        const invoicePassportElement = form.querySelector('.invoicePassport');
        invoicePassportElement.value = '';

        doSubmit(form);
      },
    );
  },
};
